/**=========================================================
 * Module: app-timeline.js
 * Handles timeline or messageboard
 =========================================================*/

App.directive('appTimeline', function(){
  'use strict';

  return {
      templateUrl: '/app/views/partials/timeline.html',
      restrict: 'E',
      replace: true
  };

});